import React from 'react';
// import Chart from 'react-apexcharts';

import dynamic from 'next/dynamic';

const Chart = dynamic(() => import('react-apexcharts'), { ssr: false });
import * as styles from './index.module.scss';
import classNames from 'classnames';
import useIsMobile from '../../../hooks/useIsMobile';

const AreaEchart = () => {
  const isMobile = useIsMobile();
  const series = [
    {
      name: 'Team',
      data: [
        0, 0, 0, 0, 19687500, 39375000, 59062500, 78750000, 98437500, 118125000,
        137812500, 157500000, 177187500, 196875000, 216562500, 236250000,
        255937500, 275625000, 295312500, 315000000,
      ],
      color: '#EA4A66',
    },
    {
      name: 'Investors',
      data: [
        0, 0, 0, 0, 19687500, 39375000, 59062500, 78750000, 98437500, 118125000,
        137812500, 157500000, 177187500, 196875000, 216562500, 236250000,
        255937500, 275625000, 295312500, 315000000,
      ],
      color: '#FF9D28',
    },
    {
      name: 'Treasury',
      data: [
        4375000, 26250000, 39375000, 52500000, 60375000, 68250000, 76125000,
        84000000, 89250000, 94500000, 99750000, 105000000, 105000000, 105000000,
        105000000, 105000000, 105000000, 105000000, 105000000, 105000000,
      ],
      color: '#877BEB',
    },
    {
      name: 'Validators Mining',
      data: [
        0, 2187500, 8750000, 15312500, 21875000, 28437500, 35000000, 41562500,
        48125000, 54687500, 61250000, 67812500, 74375000, 80937500, 87500000,
        94062500, 100625000, 106093750, 109375000, 112656250,
      ],
      color: '#F5B7BF',
    },
    {
      name: 'Tournament Rewards',
      data: [
        8750000, 52500000, 78750000, 105000000, 131250000, 157500000, 183750000,
        210000000, 236250000, 262500000, 288750000, 315000000, 341250000,
        367500000, 393750000, 420000000, 437500000, 450625000, 463750000,
        476875000,
      ],
      color: '#FFE185',
    },
  ];

  const categories = [
    'Jul',
    'Jan',
    'Apr',
    'Jul',
    'Oct',
    'Jan',
    'Apr',
    'Jul',
    'Oct',
    'Jan',
    'Apr',
    'Jul',
    'Oct',
    'Jan',
    'Apr',
    'Jul',
    'Oct',
    'Jan',
    'Apr',
    'Jul',
    'Oct',
  ];
  return (
    <div className={classNames(styles.echarts2)}>
      <div className={styles.title}>
        <img src="https://cdn-web.mtt.xyz/static/Frame%2048098471.png" alt="" />
        Token Unlock Schedule
      </div>
      <div className={styles.echartContent}>
        <Chart
          type="area"
          width="100%"
          height={isMobile ? '328px' : '100%'}
          series={series}
          styles={{
            paddingBottom: '100px',
          }}
          options={{
            tooltip: {
              x: {
                formatter(val, opts) {
                  return categories[val] + '    (million)';
                },
              },
            },
            stroke: {
              width: 2,
              curve: 'straight',
            },
            grid: {
              show: false, // 隐藏网格线
            },
            dataLabels: {
              enabled: false,
            },
            fill: {
              type: 'solid',
              opacity: 0.8,
            },
            chart: {
              type: 'area',
              stacked: true,

              toolbar: {
                show: false, // 设置为 false 以隐藏工具栏
              },
              zoom: {
                enabled: false, // 可选：禁用缩放
              },
            },
            legend: {
              show: true,
              position: 'top',
              onItemHover: {
                highlightDataSeries: false, // 鼠标悬停时是否高亮数据系列
              },
              labels: {
                colors: ['#EA4A66', '#FF9D28', '#877BEB', '#F5B7BF', '#FFE185'],
              },
            },
            xaxis: {
              type: 'category',

              labels: {
                // rotate: -25,
                // rotateAlways: true,
                style: {
                  colors: '#fff',
                  fontFamily: 'Inter',
                  fontWeight: 500,
                  fontSize: `${isMobile ? '5px' : '15px'}`,
                },
              },
              categories: categories,
            },

            yaxis: {
              min: 0,
              max: 1400000000,
              tickAmount: 7,
              labels: {
                formatter(val, opts) {
                  const simplifiedNumber = val / 1000000; // 将数字转换为百万
                  return new Intl.NumberFormat('en-US', {
                    maximumFractionDigits: 0, // 设置小数位数为0
                  }).format(simplifiedNumber);
                },
                style: {
                  colors: '#fff',
                  fontFamily: 'Inter',
                  fontWeight: 500,
                  fontSize: `${isMobile ? '5px' : '15px'}`,
                },
              },
            },
          }}
        />
        <div className={styles.million}>(million)</div>
        <div className={classNames(styles.year, styles.year1)}>2024</div>
        <div className={classNames(styles.year, styles.year2)}>2025</div>
        <div className={classNames(styles.year, styles.year3)}>2026</div>
        <div className={classNames(styles.year, styles.year4)}>2027</div>
        <div className={classNames(styles.year, styles.year5)}>2028</div>
        <div className={classNames(styles.year, styles.year6)}>2029</div>
      </div>
    </div>
  );
};

export default AreaEchart;
